// 韻の「揺れ」をユーザーが選べるトグル（Pass2 の射影パラメータ）。
// これらは「どんな母音列を『同じ韻』とみなすか」を決める。既定値は日本語ラップの
// 一般的な感覚（撥音ゆるく・促音無視・長音はのばす）に合わせている。

/** 長音「ー」: のばす（直前母音を継承）/ のばさない（無視） */
export type ChoonMode = 'inherit' | 'ignore'
/** 促音「っ」: 無視（母音列に出さない）/ 区切り（Q を残して別扱い） */
export type SokuonMode = 'skip' | 'boundary'
/** 撥音「ん」: ゆるく（母音列に出さない）/ きっちり（N を残す） */
export type HatsuonMode = 'exclude' | 'include'

export interface Flags {
  choon: ChoonMode
  sokuon: SokuonMode
  hatsuon: HatsuonMode
  /**
   * 長音化ヒューリスティック（上級・既定OFF）。純母音の並び `ou`→`oo`, `ei`→`ee` を
   * 両側対称に書き換え、「東京 トウキョウ」= oooo のように綴りの ou/ei を長音として揃える。
   * 副作用として「追う オウ」も oo になる割り切り。
   */
  longVowelNorm: boolean
}

export const DEFAULT_FLAGS: Flags = {
  choon: 'inherit',
  sokuon: 'skip',
  hatsuon: 'exclude',
  longVowelNorm: false,
}

/** メモ化用の安定キー。フラグの組合せごとに索引を1回だけ実体化するために使う。 */
export function flagsCacheKey(f: Flags): string {
  return `${f.choon}|${f.sokuon}|${f.hatsuon}|${f.longVowelNorm ? 1 : 0}`
}

/**
 * 長音化ヒューリスティックを最終母音キーへ適用する。
 * `ou`→`oo`, `ei`→`ee` を左から非重複で置換する（グローバル置換）。
 */
export function applyLongVowelNorm(key: string): string {
  return key.replace(/ou/g, 'oo').replace(/ei/g, 'ee')
}
